<template>
<footer>
    <div class="container">
        <div class="row">
            <div class="co-12 col-lg-2">
                <ul class="footer-logos list-unstyled">
                    <li>
                    <a href="https://www.gov.co/home/" title="Ir a gov.co" target="_blank" accesskey="U" tabindex="0">
                    <img class="img-header" src="https://cdn.www.gov.co/assets/images/logo.svg" height="30" width="140" alt="GOV.CO | Gobierno de Colombia">
                    </a>
                    </li>
                    <li>
                    <a href="https://www.colombia.co/" title="Ir a Colombia.co" target="_blank" accesskey="U" tabindex="0">
                    <img class="img-footer-co" src="../assets/Marca_país_Colombia_logo.svg.png" alt="CO - Colombia">
                    </a>
                    </li>
                </ul>
            </div>
            <div class="col-12 col-lg-6">
                <div class="info-ANSV">
                    <ul class="nopadding desc-footer1 list-unstyled">
                        <li class="children1">ANSV - Agencia Nacional de Seguridad Vial</li>
                        <li class="children2">Prueba teórica Licencia de conducción</li>
                    </ul>
                    <ul class="nopadding desc-footer2 list-unstyled">
                        <li>Calle 24 # 60 - 50 Piso 9</li>
                        <li>Centro Comercial Gran Estación ||</li>
                        <li>Bogotá, D.C - Colombia</li>
                        <li>Código Postal 111321</li>
                    </ul>
                    <ul class="nopadding desc-footer3 list-unstyled">
                        <li>Horario de atención canal virtual (PQRSD)</li>
                        <li>Lunes a Viernes de 8:00 a.m. - 5:00 p.m.</li>
                        <li>Jornada Continua</li>
                    </ul>
                </div>
            </div>

            <div class="col-12  col-lg-4 ">
                <div class="info-contacto">
                    <ul class="nopadding desc-footer1 list-unstyled">
                       <li>Contacto</li>
                    </ul>
                    <ul class="nopadding desc-footer2 list-unstyled">
                        <li>Teléfono conmutador +57 601 7399080</li>
                        <li>Correo de notificaciones judiciales</li>
                        <li><a href="/">notificacionesjuridicas@ansv.gov.co</a></li>
                    </ul>
                    <ul class="nopadding desc-footer3 list-unstyled">
                        <li><a href="/">Términos y condiciones</a></li>
                        <li><a href="/">Política de tratamientos de datos</a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    </footer>
</template>

<script>
export default {
    name: 'FooterPage',
}
</script>

<style lang="scss">
// @import '@/fonts/fonts.scss';
    footer{ 
        // font-family: $work-regular;
        background: #3366cc;
        color: white;
        padding-top: 3%;

        .footer-logos{ 
            li { 
                margin-bottom: 21%;
                    .img-footer-co{ 
                        height: 100px;
                    }
            }
        }
        

        .info-ANSV{ 
            padding-left: 4%;
            border-right: 1px solid #fff;
            border-left: 1px solid #fff;

                .desc-footer1{ 
                    line-height: 1.7;
                    margin-bottom: 7%;

                    .children1{
                        font-weight: 700;
                        font-size: 16px;
                    }
                    .children2{
                        font-weight: 700;
                        font-size: 14px;
                    }
                }
                .desc-footer2{ 
                    padding-bottom: 10px;
                    font-size: 14px;
                    line-height: 1.5;
                }
                .desc-footer3{ 
                    padding-bottom: 10px;
                    font-size: 13px;
                    line-height: 1.5;
                }
         }

         .info-contacto{ 
                .desc-footer1{ 
                    line-height: 1.7;
                    margin-bottom: 10%;

                    li{ 
                        font-weight: 700;
                        font-size: 16px;
                    }
                }
                .desc-footer2{ 
                    padding-bottom: 10px;
                    font-size: 14px;
                    line-height: 1.5;
                }
                .desc-footer3{ 
                    padding-top: 20px;
                    font-size: 13px;
                    line-height: 1.5;
                }
         }
            a{ 
                color: #F0F0F0;
                
                &:hover {
                    color: #F0F0F0;
                }
            }

    }

</style>